import { render, staticRenderFns } from "./GroupsEconomicList.vue?vue&type=template&id=da8cd77c&scoped=true"
import script from "./GroupsEconomicList.vue?vue&type=script&lang=ts"
export * from "./GroupsEconomicList.vue?vue&type=script&lang=ts"
import style0 from "./GroupsEconomicList.vue?vue&type=style&index=0&id=da8cd77c&prod&lang=scss&scoped=true"
import style1 from "./GroupsEconomicList.vue?vue&type=style&index=1&id=da8cd77c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8cd77c",
  null
  
)

export default component.exports